import { render } from "./PayrollSyncWorkplaces.vue?vue&type=template&id=80999d3c&scoped=true&lang=pug"
import script from "./PayrollSyncWorkplaces.vue?vue&type=script&lang=js"
export * from "./PayrollSyncWorkplaces.vue?vue&type=script&lang=js"

import "./PayrollSyncWorkplaces.vue?vue&type=style&index=0&id=80999d3c&scoped=true&lang=scss"

import exportComponent from "/builds/wiwdata/applications/finance-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80999d3c"]])

export default __exports__